import { format } from 'date-fns';

const EMPTY_DATE = {
  month: null,
  day: null,
  full: null,
};

export const formatRowDate = (date?: string | Date | null) => {
  if (!date) return EMPTY_DATE;

  const parsedDate: Date = new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return EMPTY_DATE;
  }

  return {
    month: format(parsedDate, 'MMMM, d'),
    day: format(parsedDate, 'eeee'),
    full: format(parsedDate, 'MMM d, yyyy'),
  };
};

export const formatQuestionAskedDate = (date?: string | null, locale = 'en'): string | null => {
  if (!date) return null;

  const dateToParse = date.includes('T') ? date : `${date}T00:00:00Z`;
  const parsedDate = new Date(dateToParse);
  if (isNaN(parsedDate.getTime())) {
    return null;
  }

  const dateFormatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
  const weekdayFormatter = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    timeZone: 'UTC',
  });

  return `${dateFormatter.format(parsedDate)} · ${weekdayFormatter.format(parsedDate)}`;
};
